<template>
  <div class="c-landing-wrapper c-landing-wrapper u-bg--white">
    <navigation />

    <homepage-header />

    <homepage-benefits />

    <homepage-product-list />

    <homepage-video-list />

    <homepage-article-list />

    <homepage-testimony-list />

    <homepage-footer />

    <seo-text />
  </div>
</template>
<script>
/* istanbul ignore file */
import Navigation from 'seo-desktop/components/Navigation';
import SeoText from 'seo-desktop/components/SeoText';
import HomepageHeader from './components/Header';
import HomepageBenefits from './components/Benefits';
import HomepageProductList from './components/ProductList';
import HomepageVideoList from './components/VideoList';
import HomepageArticleList from './components/ArticleList';
import HomepageTestimonyList from './components/TestimonyList';
import HomepageFooter from './components/Footer';

export default {
  name: 'HomePage',
  components: {
    Navigation,
    HomepageHeader,
    HomepageBenefits,
    HomepageProductList,
    HomepageVideoList,
    HomepageArticleList,
    HomepageTestimonyList,
    HomepageFooter,
    SeoText,
  },
};
</script>
